// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubCategory-subCategoryListContainer-GGe46 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  grid-gap: 24px;
  margin-top: 24px;
}

.SubCategory-subCategoryListItem-zG3Rh {
  background: var(--background-primary);
  border-radius: var(--radius-3);
  padding: 12px;
}

.SubCategory-subCategoryNoListItem-YEamF {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: var(--secondary-foreground);
}

.SubCategory-subCategoryNoListImgContainer-hDqa0 {
  width: 188px;
  height: 178px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 24px;
}

.SubCategory-subCategoryNoListImgContainer-hDqa0 img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
     object-fit: contain;
}

.SubCategory-viewSubCategoryLoaderContainer-yw0fF {
  padding: 120px 0;
  margin-top: 24px;
}

@media (max-width: 1199px) and (min-width: 576px) {
  .SubCategory-subCategoryListContainer-GGe46 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 575px) {
  .SubCategory-subCategoryListContainer-GGe46 {
    grid-template-columns: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewCategory/ViewSubCategory/SubCategory/SubCategory.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".subCategoryListContainer {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n  grid-gap: 24px;\n  margin-top: 24px;\n}\n\n.subCategoryListItem {\n  background: var(--background-primary);\n  border-radius: var(--radius-3);\n  padding: 12px;\n}\n\n.subCategoryNoListItem {\n  margin-top: 24px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 26px;\n  color: var(--secondary-foreground);\n}\n\n.subCategoryNoListImgContainer {\n  width: 188px;\n  height: 178px;\n  margin: 0 auto;\n  position: relative;\n  margin-bottom: 24px;\n}\n\n.subCategoryNoListImgContainer img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.viewSubCategoryLoaderContainer {\n  padding: 120px 0;\n  margin-top: 24px;\n}\n\n@media (max-width: 1199px) and (min-width: 576px) {\n  .subCategoryListContainer {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 575px) {\n  .subCategoryListContainer {\n    grid-template-columns: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subCategoryListContainer": `SubCategory-subCategoryListContainer-GGe46`,
	"subCategoryListItem": `SubCategory-subCategoryListItem-zG3Rh`,
	"subCategoryNoListItem": `SubCategory-subCategoryNoListItem-YEamF`,
	"subCategoryNoListImgContainer": `SubCategory-subCategoryNoListImgContainer-hDqa0`,
	"viewSubCategoryLoaderContainer": `SubCategory-viewSubCategoryLoaderContainer-yw0fF`
};
module.exports = ___CSS_LOADER_EXPORT___;
